import { render, staticRenderFns } from "./RmpDigitalSignatureInstructionsDialog.vue?vue&type=template&id=676e4526"
import script from "./RmpDigitalSignatureInstructionsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpDigitalSignatureInstructionsDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports